
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Document } from '@/models/Document'
import { Invoice } from '@/models/accounting/Invoice'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import Notification from '@/classes/Notification'
import i18n from '@/i18n'

@Component({
	components: { ConfirmationDialog }
})
export default class InvoiceAttachments extends Vue {
	@Prop({ required: true })
	invoice!: Invoice

	isLoading = false
	deleteConfirmationOpen: boolean = false
	selectedDocument: Document | null = null

	documents: Array<Document> = []

	async created() {
		await this.fetchDocuments()
	}

	async fetchDocuments() {
		this.isLoading = true

		try {
			this.documents = (await this.invoice.documents().get()).getData() as Array<Document>
		} finally {
			this.isLoading = false
		}
	}

	async removeDocument() {
		if (!this.selectedDocument) return
		this.deleteConfirmationOpen = false
		this.selectedDocument.isLoading = true
		const docToRemove = this.selectedDocument
		this.selectedDocument = null

		await docToRemove.delete()
		await Notification.Success(i18n.t('transports.document.deleteSuccess'))

		const index = this.documents.indexOf(docToRemove)
		if (index !== -1) {
			this.documents.splice(index, 1)
		}
	}
}
